<template>
  <div class="ui grid">
    <div class="ten wide column">
      <estero-editor
        :height="'200px'"
        :value="editorCode"
        :operators="operators"
        :properties="properties"
        :labelText="$t('ESTERO_ADVANCED_EDITOR_LABEL')"
        :helpLink="$t('ESTERO_ADVANCED_EDITOR_HELP_LINK')"
        v-on:contentchanged="storeView($event)"
        @run-query="onViewCodeUpdated"
      ></estero-editor>

      <div class="ui form">
        <div class="sixteen wide field">
          <div class="ui small icon right floated buttons">
            <button class="ui button" :title="$t('NEW')" v-on:click="resetView">
              <i class="recycle icon"></i>
            </button>
            <button class="ui button" v-on:click="saveView()" :class="{ loading: viewSaving }">
              <i class="save icon"></i>
            </button>
            <button class="ui green button" v-on:click="onViewCodeUpdated">
              <i class="running icon"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="six wide column">
      <saved-views
        :views="views"
        :selectedViewId="selectedViewId"
        @goto="gotoView"
        @delete="deleteView"
        @save="saveView"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api' // needs to be imported this way in order to include only subset of languages
import EsteroEditor from './EsteroEditor'
import { Estero } from 'services'
import { SavedViews } from 'ui'

export default {
  name: 'estero-advanced',
  components: { EsteroEditor, SavedViews },
  props: ['viewId', 'code', 'operators', 'properties'],
  data() {
    return {
      editorCode: this.code,
      viewEditor: null,
      loadedView: null,
      viewSaving: false,
      views: []
    }
  },

  computed: {
    selectedViewId() {
      return this.loadedView?.id
    }
  },

  methods: {
    onViewCodeUpdated() {
      this.$emit('run-code', this.editorCode)
    },

    gotoView(v) {
      this.editorCode = v.code
      this.$emit('goto-view', { id: v.id, code: v.code })
    },

    refreshViews() {
      Estero.getViews().then(views => {
        this.views = views
        if (this.viewId) {
          this.loadView(this.views, this.viewId)
        }
      })
    },

    loadView(views, viewId) {
      const v = _.find(views, v => v.id == viewId)
      if (v) {
        this.loadedView = v
        this.editorCode = v.code
      }
    },

    storeView(v) {
      this.editorCode = v
    },

    deleteView(v) {
      Estero.deleteView(v.id).finally(this.refreshViews)
    },

    resetView() {
      this.loadedView = null
      this.editorCode = ''
      this.onViewCodeUpdated()
    },

    saveView(v) {
      if (!v) v = this.loadedView
      this.viewSaving = true
      Estero.saveView(v?.id, v?.name, v?.version, this.editorCode).finally(() => {
        this.viewSaving = false
        this.refreshViews()
      })
    }
  },
  watch: {
    viewId: function() {
      this.refreshViews()
    },
    code: function(newView) {
      this.editorCode = newView
    },
    viewFilter: function() {
      // Reset page in saved views on filter
      this.viewPage = 0
    }
  },
  mounted() {
    this.refreshViews()
    this.editorCode = this.code
  }
}
</script>
